import { Input } from 'antd';

export const LCInputSearch = Input.Search;
